import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import styles from './SuspenseFallback.module.scss?module';
import { useEffect, useState } from 'react';


export default function SuspenseFallback() {
  const [renderFallback, setRenderFallback] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setRenderFallback(true);
    }, 500);
  }, []);

  if (renderFallback)
    return (
      <div className={styles.wrapper}>
        <div className={styles.card}>
          <FontAwesomeIcon icon={faArrowsRotate} className={styles.icon} spin />
          <p className={styles.text}>Please wait content is Loading...</p>
        </div>
      </div>
    );

  return <></>;
}
